// Tiny shared live-data store so the Map Editor can track the live RPM/load point
// produced by the Flash Tools live-data poll (bridge). Module-level singleton.
let latest = null;
const subs = new Set();

export const setLive = (d) => {
  latest = d;
  subs.forEach((fn) => { try { fn(d); } catch (_) { /* ignore */ } });
};

export const getLive = () => latest;

export const subscribeLive = (fn) => {
  subs.add(fn);
  return () => subs.delete(fn);
};
